import isEmpty from "lodash/isEmpty";

import { getFormattedDate, isBetween } from "@stadium/helpers/dayjs";

import { AppGenericAnnouncementBarFlagValueType } from "@stadium/ui/src/components/app-generic-announcement-bar";

import { DATE_FORMAT_MM_DD_YYYY_DASH } from "@stadium/helpers/dayjs/constants";

const ACTIVE_PACKAGE_USER_KEY = "active_package_user";

export const isAppGenericAnnouncementBarFlagEnabled = (
  flagValue: AppGenericAnnouncementBarFlagValueType,
  application: string,
  isActivePackageUser?: boolean,
) => {
  if (isEmpty(flagValue)) return false;

  const { applications, startDate, endDate, audiences = [] } = flagValue;

  const hideBanner = audiences[0] === ACTIVE_PACKAGE_USER_KEY && !isActivePackageUser;

  if (!applications.includes(application) || hideBanner) return false;

  const formattedStartDate = getFormattedDate(startDate, DATE_FORMAT_MM_DD_YYYY_DASH);
  const formattedEndDate = getFormattedDate(endDate, DATE_FORMAT_MM_DD_YYYY_DASH);

  const isBetweenDates = isBetween(new Date(), formattedStartDate, formattedEndDate);

  if (!isBetweenDates) return false;

  return true;
};
